import { useState } from "react";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  // status: 'idle' | 'sending' | 'success' | 'error'
  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status === "sending" || status === "success") return;

    const payload = {
      name: name.trim(),
      email: email.trim(),
      message: message.trim(),
    };

    if (!payload.name || !payload.email || !payload.message) {
      setStatus("error");
      setErrorMessage("Please fill in your name, email and message.");
      return;
    }

    setStatus("sending");
    setErrorMessage("");

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));

      if (!response.ok || !result.ok) {
        throw new Error(result.error || "Message failed to send.");
      }

      setStatus("success");
      clearState();
      setTimeout(() => setStatus("idle"), 3500);
    } catch (error) {
      setStatus("error");
      setErrorMessage(
        "Message failed. Please try again or contact us directly."
      );
    }
  };

  const isSending = status === "sending";
  const isSuccess = status === "success";
  const isError = status === "error";

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Let's build the AI era together. Leave us a message and our team will get back to you shortly.
                </p>
              </div>
              <form name="sentMessage" noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={name}
                        onChange={handleChange}
                        disabled={isSending || isSuccess}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={handleChange}
                        disabled={isSending || isSuccess}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={message}
                    onChange={handleChange}
                    disabled={isSending || isSuccess}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>

                <div
                  className={`contact-status ${
                    isSuccess || isError ? "contact-status-visible" : ""
                  } ${isError ? "contact-status-error" : ""}`}
                  role="status"
                  aria-live="polite"
                >
                  {isSuccess && (
                    <>
                      <span className="contact-status-check">
                        <i className="fa fa-check" />
                      </span>
                      <div className="contact-status-text">
                        <strong>Message sent.</strong> Thanks — our team will get back to you within 1 business day.
                      </div>
                    </>
                  )}
                  {isError && (
                    <>
                      <span className="contact-status-check">
                        <i className="fa fa-exclamation" />
                      </span>
                      <div className="contact-status-text">
                        <strong>Could not send.</strong> {errorMessage}
                      </div>
                    </>
                  )}
                </div>

                <button
                  type="submit"
                  className={`btn btn-custom btn-lg contact-submit ${
                    isSending ? "is-sending" : ""
                  } ${isSuccess ? "is-success" : ""}`}
                  disabled={isSending || isSuccess}
                >
                  {isSending && (
                    <>
                      <i className="fa fa-spinner fa-spin contact-submit-icon" />
                      Sending...
                    </>
                  )}
                  {isSuccess && (
                    <>
                      <i className="fa fa-check contact-submit-icon" />
                      Message Sent
                    </>
                  )}
                  {!isSending && !isSuccess && "Send Message"}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
